export default __webpack_public_path__ + "static/media/not-found.be107660.png";